/**
 * Бар управления скрытием позиций очереди (только GENERAL_DIRECTOR).
 * Обычный режим: «Скрыть у себя (N)» при выделении + «Показать скрытые (N)».
 * Режим «Показать скрытые»: возврат позиций в очередь.
 * Рендерится только когда роль может скрывать (canHide).
 */
export function QueueHideBar({
  canHide,
  hiddenCount,
  showHidden,
  selectedCount,
  busy,
  onHideSelected,
  onUnhideSelected,
  onUnhideAll,
  onToggleShowHidden,
}: {
  canHide: boolean
  hiddenCount: number
  showHidden: boolean
  selectedCount: number
  busy: boolean
  onHideSelected: () => void
  onUnhideSelected: () => void
  onUnhideAll: () => void
  onToggleShowHidden: (next: boolean) => void
}) {
  if (!canHide) return null

  if (showHidden) {
    return (
      <div className="flex flex-wrap items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2">
        <span className="text-sm font-medium text-amber-800">
          Скрытые позиции{hiddenCount > 0 ? ` (${hiddenCount})` : ''}
        </span>
        <span className="text-xs text-amber-700">— видите только вы; вернуть в очередь:</span>
        <div className="ml-auto flex flex-wrap items-center gap-2">
          <button
            type="button"
            disabled={busy || selectedCount === 0}
            onClick={onUnhideSelected}
            className="px-3 py-1.5 text-sm font-medium bg-brand-600 text-white rounded-lg hover:bg-brand-700 disabled:opacity-50"
          >
            Вернуть выделенные{selectedCount > 0 ? ` (${selectedCount})` : ''}
          </button>
          <button
            type="button"
            disabled={busy || hiddenCount === 0}
            onClick={onUnhideAll}
            className="px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Вернуть все
          </button>
          <button
            type="button"
            onClick={() => onToggleShowHidden(false)}
            className="px-3 py-1.5 text-sm font-medium text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            ← В очередь
          </button>
        </div>
      </div>
    )
  }

  // Обычный режим: показываем бар, только если есть что делать —
  // выделены позиции (можно скрыть) или уже есть скрытые (можно посмотреть).
  if (selectedCount === 0 && hiddenCount === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-2">
      {selectedCount > 0 && (
        <button
          type="button"
          disabled={busy}
          onClick={onHideSelected}
          title="Убрать выделенные позиции из своей очереди — у других и в заявках ничего не изменится"
          className="px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
        >
          Скрыть у себя ({selectedCount})
        </button>
      )}
      {hiddenCount > 0 && (
        <button
          type="button"
          onClick={() => onToggleShowHidden(true)}
          className="px-3 py-1.5 text-sm font-medium text-amber-700 border border-amber-300 bg-amber-50 rounded-lg hover:bg-amber-100"
        >
          Показать скрытые ({hiddenCount})
        </button>
      )}
    </div>
  )
}
